export enum AlarmType{
    NO_ALARM,
    SHAKE,
    HEAT,
    DISTANCE_CHANGE
}